import { AskConfirmation } from '../../../../webmodule-common/other/ui/modal-confirmation';
import { information } from '../../../../webmodule-common/other/ui/modal-option';
import { LangBranchSwitch } from '../../../../localization/scripts/dealer-franchisee/pages/helpers/branch-switch-lang';
import { userDataStore } from '../../common/current-user-data-store';

/**
 * Gate for opening a quote/project/PO that may belong to another branch.
 *
 * 1. Same branch → open immediately.
 * 2. Cross-branch and user can access the target → confirm switch, then open.
 * 3. Otherwise → show that the resource is not part of the user's branches.
 *
 * `hasBranch` already applies usable/hidden branch access rules.
 */
export async function branchSwitchOnResource(resourceBranchId: string, resourceName: string): Promise<boolean> {
  // Without a usable default branch, the resource cannot be opened in context.
  if (!userDataStore.hasAvailableBranches()) {
    await information(LangBranchSwitch.branchSwitchNotPartOfBranch({ resourceName }));
    return false;
  }

  const currentBranch = userDataStore.defaultBranch;
  if (resourceBranchId === currentBranch.id) return true;

  // Target must be a usable branch for this user.
  if (!userDataStore.hasBranch(resourceBranchId)) {
    await information(LangBranchSwitch.branchSwitchNotPartOfBranch({ resourceName }));
    return false;
  }

  const branch = userDataStore.branchById(resourceBranchId);
  const confirmed = await AskConfirmation(
    LangBranchSwitch.branchSwitchConfirmation({
      resourceName,
      branchName: branch.name,
      defaultBranchName: currentBranch.name
    })
  );
  if (!confirmed) return false;

  userDataStore.defaultBranch = branch;
  return true;
}
